import styled from 'styled-components';
import { Breakpoint, FONT_STACK, Orientation } from '../../../styles/constants';

export const View = styled.div`
  ${FONT_STACK};
  padding-bottom: 84px;
  width: 100%;

  ${Orientation.LANDSCAPE} {
    padding-bottom: 0;
  }

  ${Breakpoint.SMALL} {
    padding-bottom: 0;
  }
`;
